<template>
  <div class="columns is-centered is-mobile">
    <div class="column closed-account-form-wrapper">
      <div class="closed-account-form">
        <div class="closed-account-form__icon">
          <b-icon pack="far" icon="user-circle"></b-icon>
        </div>
        <div class="closed-account-form__title">Sorry, your Enhancify account has been closed</div>
        <div class="closed-account-form__subtitle">
          This happened because you are no longer our partner.
          If you think this is a mistake or you want to return
          to the Enhancify Partner program, you can contact
          <a :href="`mailto:${email}`">{{ email }}</a>
          or call
          <a :href="`tel:${tel}`">{{ getManagerCSOPhoneFormatted }}</a>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClosedAccount',

  data() {
    return {
      tel: '+18134999879',
      email: 'support@enhancify.com',
    };
  },

  computed: {
    getManagerCSOPhoneFormatted() {
      return this.tel
        .replace(/^\+\d/, '')
        .replace(/^(\d{3})(\d{3})(\d+)$/, '$1-$2-$3');
    },
  },
};
</script>

<style scoped lang="stylus">
@require "../assets/style/modern/variables.styl";
.closed-account-form-wrapper
  display flex
  justify-content center
  padding-right 0
  .closed-account-form
    @media (max-width: $breakpoints.md)
      padding 30px 16px
    max-width 750px
    margin 20px 20px 0 20px
    width 100%;
    background white
    border-radius 6px
    padding 30px 55px
    box-shadow 0 18px 32px rgba(156, 173, 173, 0.2);
    color #293033
    &__icon, &__title, &__subtitle, &__subtitle_bold
      text-align center
    &__item
      margin-bottom 10px
    &__icon
      margin-bottom 15px
      color: #17B548
      font-size 2rem
    &__title
      font-weight bold
      font-size 28px
      margin-bottom 10px
      color #293033
    &__subtitle, &__subtitle_bold
      margin-bottom 30px
      font-size 18px
      color #293033
  .closed-account
    background #0743bf1c
    padding 15px
    border-radius 6px
</style>
